<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nKDCMa/tc-custom/9780830884414.jpg?1684571221769?1696024362841" alt="This image is the cover for the book Matthew: The Gospel of Identity, The Biblical Imagination Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Matthew: The Gospel of Identity, The Biblical Imagination Series
      </h1>
      <p class="bookDescription body article font2">
        <p>"You are the salt of the earth . . . You are the light of the world." Matthew 5:13-14 "I also say to you that you are Peter, and on this rock I will build My church." Matthew 16:18 The world tries to define us in different ways. We try to define ourselves one way or another. But who are we really? How does God define us? The Gospel of Matthew was written to a group of Christians who didn?t yet know who they were. They were faithful Jews in the synagogue community in Galilee who had found the Messiah. Jesus had changed everything. But how should they think of themselves now, as Jewish or Christian? What did it all mean? Matthew writes his Gospel to help his readers define their new identity as followers of Jesus the Messiah. Michael Card unpacks how Matthew?s emphasis on fulfillment confirms their Jewish connection to the Torah, while his focus on the kingdom helps them understand their new identities in Christ. Matthew presents this process of redefinition as an exercise of the imagination, in which Jesus reshapes who we are in light of who he is. Come alongside Matthew in this pilgrimage, and discover how your new identity in Christ fulfills all that you are meant to be.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Card
      </h2>
      
      <p class="authorDescription body article"><p>In a career that spans 30 years, Michael Card has recorded over 31 albums, authored or co-authored over 24 books, hosted a radio program, and written for a wide range of magazines. An award-winning musician and performing artist, he has penned such favorites as "El Shaddai," "Immanuel" and many other songs. He has branched his ministry beyond music and written numerous books, including<em>A Sacred Sorrow, A Violent Grace, The Parable of Joy</em> and <em>Sleep Sound in Jesus</em> (a children's book). He has also written the <em>Biblical Imagination Series,</em> with a book and accompanying music CD for each of the four gospels. A graduate of Western Kentucky University with a bachelor's and master's degree in biblical studies, Card also serves as mentor to many younger artists and musicians, teaching courses on the creative process and calling the Christian recording industry into deeper discipleship. Card lives in Tennessee with his wife and four children.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f22f7bb6